module.exports = __webpack_public_path__ + "img/banner_left.53006d4b.png";